import { NavLink } from 'react-router-dom';

interface ServiceNavProps {
  activePath?: string;
}

const ITEMS = [
  // [법인 전환 후 활성화] 실시간 시세 기능 — 현재 비활성화
  // { to: '/market', label: '시세' },
  // { to: '/virtual', label: '모의투자' },
  { to: '/calendar', label: '주요일정' },
  { to: '/events', label: '이벤트' },
  { to: '/ranking', label: '랭킹' },
];

/**
 * 서비스 공통 GNB — 회색 pill (2026-04-18 재정의)
 * - 부모 nav: 투명
 * - pill 컨테이너: bg-[#e5e5e5] rounded-md p-1 (작은 패딩)
 * - 선택 탭: bg-white rounded-md font-semibold text-[var(--color-text)] px-3 py-1.5
 *   (게시판 '최신순' 버튼과 동일 스타일)
 * - 미선택 탭: bg-transparent text-gray-500 hover:text-gray-700 px-3 py-1.5
 */
export function ServiceNav({ activePath }: ServiceNavProps) {
  return (
    <nav className="mb-6">
      <div className="scrollbar-hide inline-flex max-w-full gap-1 overflow-x-auto rounded-md bg-[var(--color-tab-bg)] p-1 md:flex md:flex-wrap md:overflow-visible">
        {ITEMS.map(({ to, label }) => {
          const useActive = activePath ? activePath === to : undefined;
          return (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) => {
                const active = useActive ?? isActive;
                return `shrink-0 rounded-md px-3 py-1.5 text-sm transition-colors ${
                  active
                    ? 'bg-[var(--color-tab-active)] font-semibold text-[var(--color-text)]'
                    : 'bg-transparent text-[var(--color-text-sub)] hover:text-[var(--color-text)]'
                }`;
              }}
            >
              {label}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
